/* global requestAnimationFrame */
jQuery( () => {
	const elasticSearchElement = document.querySelector( '.js-elastic-search' );
	const hideClass = 'is-hidden';

	wp.hooks.addFilter( 'qalaElasticFilters.filter.pagerScrollTo', 'PagerScrollToFilter', scrollTo => {
		// Scroll to the top of the qala elastic filters container instead of the top of the page
		const resultsContainer = document.querySelector( '.qesf-container' );
		if ( resultsContainer ) {
			const rect = resultsContainer.getBoundingClientRect();

			// Offset by the sticky menu height so it doesn't hide the top of the products
			let headerOffset = 0;
			const menu = document.querySelector( '.site-header' );
			const menuNavigation = menu?.querySelector( '.main-navigation' );
			if ( menu && menuNavigation ) {
				const menuStyles = window.getComputedStyle( menu );
				const isSticky = menu.classList.contains( 'is-sticky' ) ||
					menuStyles.position === 'sticky' ||
					menuStyles.position === 'fixed';

				if ( isSticky ) {
					headerOffset = menuNavigation.offsetHeight;
					document.querySelectorAll( '.js-is-sticky-header-bar' ).forEach( bar => {
						headerOffset += bar.offsetHeight;
					} );
				}
			}

			return { x: 0, y: window.scrollY + rect.top - headerOffset };
		}

		return scrollTo; // Default fallback
	} );

	if ( ! elasticSearchElement ) {
		return;
	}

	const elasticSearchLoader = elasticSearchElement.querySelector( '.js-elastic-search-loader' );
	const containerElement = elasticSearchElement.querySelector( '.js-qesf-search-page-header-has-results-container' );
	const paginationElement = elasticSearchElement.querySelector( '#qesf-pagination' );
	const resultsElement = elasticSearchElement.querySelector( '[data-name="qec-results"]' );
	const element404 = elasticSearchElement.querySelector( '.js-qesf-search-page-404' );
	let timeout = null;

	wp.hooks.addAction( 'qalaElasticCore.action.beforeQuery', 'QalaTheme', () => {
		if ( timeout ) {
			clearTimeout( timeout );
		}

		if ( ! elasticSearchLoader.classList.contains( hideClass ) ) {
			return;
		}

		elasticSearchLoader.classList.remove( hideClass );
	} );

	wp.hooks.addAction( 'qalaElasticCore.action.onResult.meta', 'QalaTheme', meta => {
		if ( timeout ) {
			clearTimeout( timeout );
		}

		if ( ! meta || ! meta.page ) {
			return;
		}

		timeout = setTimeout( () => {
			// Try to do everything in one go to minimize any jumping / popup.
			requestAnimationFrame( () => {
				if ( meta?.page?.total_pages === 0 ) {
					show404();
				} else {
					hide404();
				}

				if ( ! elasticSearchLoader.classList.contains( hideClass ) ) {
					elasticSearchLoader.classList.add( hideClass );
				}
			} );
		}, wp.hooks.applyFilters( 'qalaTheme.filter.elastic_search_loader_timeout', 50 ) );
	} );

	const show404 = () => {
		containerElement.classList.add( 'is-hidden' );
		element404.classList.remove( 'is-hidden' );

		paginationElement.style.display = 'none';
		resultsElement.style.display = 'none';
	};

	const hide404 = () => {
		containerElement.classList.remove( 'is-hidden' );
		element404.classList.add( 'is-hidden' );

		paginationElement.style.display = 'initial';
		resultsElement.style.display = 'initial';
	};
} );
